import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSparks24Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSparks24Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.502 2.896a.75.75 0 0 0-.75.75 2.187 2.187 0 0 1-2.186 2.188h-.001a.75.75 0 0 0 0 1.5h.001c1.208 0 2.186.98 2.186 2.187 0 .414.336.75.75.75h.005a.75.75 0 0 0 .745-.75c0-1.208.979-2.187 2.186-2.187h.001a.75.75 0 0 0 .75-.75v-.005a.75.75 0 0 0-.75-.745 2.187 2.187 0 0 1-2.187-2.188.75.75 0 0 0-.75-.75m-9.11 2.649a.75.75 0 0 0-.597.734 4.4 4.4 0 0 1-4.396 4.398h-.003a.75.75 0 1 0 0 1.5H3.4a4.4 4.4 0 0 1 4.396 4.399.75.75 0 0 0 1.5 0 4.4 4.4 0 0 1 4.398-4.399.75.75 0 0 0 0-1.5A4.4 4.4 0 0 1 9.295 6.28a.75.75 0 0 0-.903-.734m9.126 7.93a.75.75 0 0 1 .75.75v1.55a.75.75 0 0 1-1.5 0v-1.55a.75.75 0 0 1 .75-.75m0 7.7a.75.75 0 0 1-.75-.75v-1.55a.75.75 0 0 1 1.5 0v1.55a.75.75 0 0 1-.75.75m3.1-3.1a.75.75 0 1 0 0-1.5h-1.55a.75.75 0 0 0 0 1.5zm-6.95-.75a.75.75 0 0 1 .75-.75h1.55a.75.75 0 0 1 0 1.5h-1.55a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSparks24Filled);
